import React from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { IInvoiceDetailsAssignedAsset } from "models/InvoiceDetails"
import noAssetsImg from "assets/img/no-assets.svg"
import Text from "components/Text/Text"
import Button from "components/Button/Button"
import Routes from "@/routes"
import InvoiceSidebarAsset from "./InvoiceSidebarAsset"

export interface IInvoiceSidebarAssetsProps {
    assets: IInvoiceDetailsAssignedAsset[],
    invoiceId: string
    isAssignmentCompleted: boolean
}

const InvoiceSidebarAssets = ({
    assets,
    invoiceId,
    isAssignmentCompleted,
}: IInvoiceSidebarAssetsProps) => {
    const { t } = useTranslation()
    const location = useLocation()

    return (
        <>
            <Text type="h3" className="mb-3">{t('invoices.assignedAmounts')}</Text>
            {assets?.map(asset => (
                <div key={asset.id} className="py-1 border-grey-100-between">
                    <InvoiceSidebarAsset asset={asset} />
                </div>
            ))}
            {(!assets || assets.length === 0) && (
                <div className="text-center py-4">
                    <img src={noAssetsImg} alt="" className="mb-6" />
                    <div className="mb-4">
                        <Text>{t('invoices.noAmountsAssigned')}</Text>
                        {!isAssignmentCompleted &&
                            <Text>{t('invoices.wantAssignInvoiceAmount')}</Text>
                        }
                    </div>
                    {!isAssignmentCompleted &&
                        <Button
                            theme="secondary"
                            type="link"
                            url={Routes.invoiceAssignAmount.getPath({ invoiceId }, { backUrl: location.pathname })}
                            label={t('invoices.assignAmount')} />
                    }
                </div>
            )}

        </>
    )
}


export default InvoiceSidebarAssets
